<template>
  <div class="box-second" style="padding: 0 1vh;">
    <p class="title-crumb">
        <el-breadcrumb separator-class="el-icon-arrow-right color3">
            <el-breadcrumb-item>项目</el-breadcrumb-item>
            <el-breadcrumb-item>项目信息</el-breadcrumb-item>
        </el-breadcrumb>
    </p>
    <!-- <el-form ref="form" :model="form" label-width="0" style="overflow: auto;height: calc( 100% - 4vh );"> -->
      <!-- 其他平台 -->
      
      <el-card class="box-card desc-card">
        <div style="display: flex;justify-content: flex-end;">
          <!-- <el-button type="primary" >添加</el-button> -->
        </div>
        <p style="margin:0 0 5px 0;text-align: left;">其他实名制平台：</p>
        <ul class="ul_box"  v-for="item in entList" :key="item.projectEntId">
          <li style="width:10%">{{item.index}}、</li>
          <li style="width:30%">
               <div>平台名称：{{item.platformName}}</div>
               <div>平台类型：{{item.typeName}}</div>
          </li>
          <li style="width:30%">
              <div>上传状态: {{item.uploadStatus}}</div>
              <!-- <div>联系电话：{{item.personPhone}}</div> -->
          </li>
          <li style="width:30%">     
            <el-button size="mini"    @click="handleEdit(item)">编辑</el-button>
            <el-button size="mini"  v-if="item.settingId" type="danger" @click="handleDelete(item)">删除</el-button>      
          </li>
        </ul>
      </el-card>
      <el-card class="box-card desc-card">
        <p style="margin:0 0 5px 0;text-align: left;">实名制平台：</p>
        <ul class="ul_box"  v-for="item in entList1" :key="item.projectEntId">
          <li style="width:10%">{{item.index}}、</li>
          <li style="width:30%">
               <div>平台名称：{{item.platformName}}</div>
               <div>平台类型：{{item.typeName}}</div>
          </li>
          <li style="width:30%">
              <div>上传状态: {{item.uploadStatus}}</div>
              <!-- <div>联系电话：{{item.personPhone}}</div> -->
          </li>
          <li style="width:30%"> 
            <el-button size="mini"  @click="handleEdit(item)">编辑</el-button>
            <el-button size="mini"  v-if="item.settingId"   type="danger" @click="handleDelete(item)">删除</el-button>
          </li>
        </ul>
      </el-card>
    <!-- </el-form> -->
      <!-- 添加弹框 -->
      <el-dialog :title="dialogTitle" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      class="add-form"   width="30%" top="10vh" custom-class="map-dialog">
      <el-form :model="addForm" ref="addForm" label-width="150px" :label-position="labelPosition">
        <el-form-item label="appKey">
          <el-input v-model="addForm.appKey" autocomplete="off" placeholder="请输入appKey" style="width: 217px"></el-input>
        </el-form-item>
        <el-form-item label="secret:">
          <el-input v-model="addForm.secret" autocomplete="off" placeholder="请输入secret" style="width: 217px"></el-input>
        </el-form-item>
        <el-form-item label="pass:">
          <el-input v-model="addForm.pass" autocomplete="off" placeholder="请输入pass" style="width: 217px"></el-input>
        </el-form-item>
        <el-form-item label="itemId:">
          <el-input v-model="addForm.itemId" autocomplete="off" placeholder="请输入itemId" style="width: 217px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import base from '../../untils/base'
import util from '../../untils/util.js'
export default {
  data() {
    return {
      labelPosition:'right',
      groupId:'',
      entList:[],//其他
      entList1:[],
      addFormVisible: false,
      dialogTitle: '',
      addForm: {
        settingId:'',
        appKey:'',
        secret:'',
        pass:'',
        itemId:''
        },
    }
  },
  mounted() {
   this.groupId = this.$store.state.groupId
   this.getJoinEnt()
   this.getInfo()
  },
  methods: {
       //上传的其他平台信息
       getJoinEnt(){
            var that = this
            myHttp.selectPlatformListByProjectId({
                projectId:this.groupId
            }).then(function(resp){
                if (resp.data.code == '200'){
                   var entity = resp.data.data.entity
                   for(var i = 0;i<entity.length;i++){
                    entity[i].index = i+1
                   }
                   that.entList = entity

                }else{

                }
            })
        },
        // 上传的平台信息
        getInfo(){
          var that = this
            myHttp.selectPlatformListByProjectIdAndAreaId({
                projectId:this.groupId
            }).then(function(resp){
                if (resp.data.code == '200'){
                   var entity = resp.data.data.entity
                   for(var i = 0;i<entity.length;i++){
                    entity[i].index = i+1
                   }
                   that.entList1 = entity

                }else{

                }
            })
        },
        // 编辑
        handleEdit(item){
          this.addFormVisible =  true
          this.addForm.type=item.cost
          this.addForm.settingId= item.settingId
          this.addForm.secret= item.secret
          this.addForm.appKey= item.appKey
          this.addForm.pass= item.pass
          this.addForm.itemId= item.itemId

        },
        // 删除
        handleDelete(item){
          var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
            myHttp
                .deleteSetting({
                  projectId:this.groupId,
                  type: item.cost
                })
                .then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message({
                    type: 'success',
                    message: '删除成功!'
                    })
                    that.getJoinEnt()
                    that.getInfo()
                } else {
                    that.$message.error(resp.data.msg)
                }
                })
            })
            .catch(err => {})
        },
        // 将新增的数据添加到表格中
      sumbitAddRow(formName) {
        var that = this
        that.addForm.projectId = this.groupId
        that.addForm.userId = util.session.get('user').id
        console.log(that.addForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (that.addForm.settingId == '') {
         
              //添加 222
              myHttp.addOrUpdate(that.addForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('添加成功')
                    that.addFormVisible = false
                    that.currentPage = 1
                    that.getJoinEnt()
                    that.getInfo()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () { }
              )
            } else {
              //修改 1111
              // that.addForm.updateBy = util.session.get('user').id
              myHttp.addOrUpdate(that.addForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addFormVisible = false
                    that.getJoinEnt()
                    that.getInfo()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () { }
              )
            }
            // that.$message.error('功能暂未开放')
          }
        })
      },
  }
}
</script>
<style scoped>
/* .content {
  height: 100%;
  padding: 0 1vh;
  overflow: auto;
}
.title{
    width: 100%;
    height: 3vh;
    position: relative;
    display: flex;
    padding-left: 1vw;
}
.title .el-breadcrumb{
  display: flex;
  align-content: center;
  align-items: center;
} */
.box-second{
  overflow: auto;
}
.proName-box {
  background: #fff;
  padding: 20px 60px;
}
.pro-box1,
.pro-box3,
.pro-box4 {
  display: flex;
  width: 100%;
}
.box-img{
  display: flex;
  flex: 1;
}
.pro-box3,
.pro-box4 {
  flex-wrap: wrap;
}
.pro-box3 .item-con,
.pro-box4 .item-con {
  width: 100%;
  display: flex;
  margin-top: 15px;
}
.pro-box1 .item,
.item-con .item {
  width: 33%;
  display: flex;
  align-items: center;
}
.pro-box4 .item-con .item {
  width: 50%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #ddd;
  margin: 0 30px;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.box-card {
  margin-bottom: 20px;
  position: relative;
}
p {
  text-align: left;
  margin: 0;
  padding-left: 10px;
}
.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.desc-con{
  width: 100%;
  height: 6vh;
  position: relative;
  line-height: 3vh;
  color: #000;
  padding-right: 1vh;
  transition: all 1s;
}
.desc-con1{
  height:auto;
}
.desc-down{
  position: absolute;
  right: 2vh;
  bottom: 2.7vh;
  cursor: pointer;
}
.ul_box{
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  height: 100px;
}
.ul_box>li>div{
  text-align:left;
  margin: 20px 0;
}
</style>
<style>
 /* @import '../../assets/css/common.css' */
</style>